module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/Pin.d83b4001.svg";